import {
    ISetRoomInfoModalAction,
    ISetRoomPasswordErrorAction,
    ISetRoomProtectionAction,
    SET_ROOM_INFO_MODAL,
    SET_ROOM_PASSWORD_ERROR,
    SET_ROOM_PROTECTION,
} from './types/roomProtection.action.types';
import {IFetchRoomProtection} from '../../incase-domain/rooms/room.player';
import {TypedTranslation} from '../../i18n';

export const setRoomProtectionAction = (protection: IFetchRoomProtection): ISetRoomProtectionAction => ({
    type: SET_ROOM_PROTECTION,
    protection,
});

export const setPasswordErrorAction = (error: TypedTranslation | null): ISetRoomPasswordErrorAction => ({
    type: SET_ROOM_PASSWORD_ERROR,
    error,
});

export const setRoomInfoModalAction = (
    open: boolean,
    title: TypedTranslation | '',
    description: TypedTranslation | ''
): ISetRoomInfoModalAction => ({
    type: SET_ROOM_INFO_MODAL,
    modal: {open, title, description},
});
